import { render, staticRenderFns } from "./envelopeCardModal.vue?vue&type=template&id=21580cf1&scoped=true&"
import script from "./envelopeCardModal.vue?vue&type=script&lang=js&"
export * from "./envelopeCardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21580cf1",
  null
  
)

export default component.exports